<template>
  <!-- 指引 -->
  <div class="generalIntroBox" v-show="introBoxVisible">
    <!-- 引导滑块 -->
    <!-- v-show="!beforeBoxVisible" -->
    <div class="guideSlider" ref="sliderEle">

      <!-- {{this.$lang.currentLang}} -->
      <!-- 国际化：zh_CN、en_US、en_ID -->

      <!-- 箭头 -->
      <div class="arrowTo" ref="arrowToEle"></div>
      <!-- 标题 -->
      <div class="guideSliderTitle">
        <i class="titleIcon"></i>
        <!-- 1.新系统的管理设备 -->
        <span ref="varStepTitle">{{`1.${$t('intro.step_project_1')}`}}</span>
      </div>
      <div class="bottomLine"></div>
      <div class="guideSliderContent" ref="varStepContent">
        {{$t('intro.step_project_2')}}<span class="lightText">「{{$t('intro.step_project_3')}}」</span>{{$t('intro.step_project_4')}}
        <span class="lightText">{{$t('intro.step_project_5')}}</span>。
      </div>

      <!-- 辅助测试 -->
      <!-- <span>当前步骤标记：{{stepCurMark}}</span> -->

      <div class="guideSliderOperate">
        <!-- {{dotList}} -->
        <div class="stepDot">
          <span 
            v-for="(item, index) in dotList" 
            :key="index" 
            class="dotDefault"
            :class="{'dotActive': stepCurMark == item.step}"
            @click="enableDot(item)"
          ></span>
        </div>
        <div class="stepBtn">
          <!-- 退出引导 -->
          <button 
            type="button" 
            class="btnQuit" 
            @click="guideSkip" 
            v-show="stepCurMark<dotList.length-1"
          >{{$t('intro.slider_quite')}}</button>
          <!-- 上一步 -->
          <button 
            type="button" 
            class="btnPre" 
            @click="enablePreDot" 
            v-show="stepCurMark>0"
          >{{$t('intro.slider_pre')}}</button>
          <!-- 下一步 -->
          <button 
            type="button" 
            class="btnNext" 
            @click="enableNextDot" 
            v-show="stepCurMark<dotList.length-1"
          >{{$t('intro.slider_next')}}</button>
          <!-- 进入新版 -->
          <button 
            type="button" 
            class="btnNext" 
            @click="guideSkip" 
            v-show="stepCurMark>=dotList.length-1"
          >{{$t('intro.slider_enter')}}</button>
        </div>
      </div>
    </div>
    <!-- 引导前页 -->
		<!-- <div class="guideBeforeBox" v-show="beforeBoxVisible">
      <div class="mask">
        <div class="guideBeforeCell">
          <div class="guideBeforeTitle">系统升级啦！欢迎体验新版本！</div>
          <div class="guideBeforeBtn">
            <button 
              type="button" 
              class="guideBeforeBtnSkip" 
              @click="guideSkip"
            >直接进入新版</button>
            <button 
              type="button" 
              class="guideBeforeBtnEnter" 
              @click="guideEnterStepOne"
            >了解新版功能</button>
          </div>
          <div class="guideBeforeTip">新手引导可在右上角通知里再次点开</div>
        </div>
      </div>
    </div> -->
    <!-- 进入我的设备页 -->
    <!-- myDeviceBoxVisible -->
    <!-- background: url('../../assets/img/introNew/generalIntro_myDevicePage.png'); -->
    <!-- :style="`background: url(${currentLangBgi});`" -->
    <div 
      v-show="myDeviceBoxVisible"
      class="myDeviceBox"
    >
      <div class="maskLeft" ref="deviceMaskLeft"></div>
      <div class="maskRight">
        <div class="maskRightOne"></div>
        <div class="maskRightTwo" ref="deviceMaskRightTwo"></div>
        <div class="maskRightThree"></div>
      </div>
    </div>
    <!-- 进入项目管理页 -->
    <!-- proManageBoxVisible -->
    <!-- <div class="proManageBox" v-show="proManageBoxVisible">
      <div class="maskLeft"></div>
      <div class="maskRight"></div>
    </div> -->
    <!-- 进入我的设备页设备详情页 -->
    <!-- myDeviceDetailBoxVisible -->
    <!-- <div class="myDeviceDetailBox" v-show="myDeviceDetailBoxVisible">
      <div class="maskLeft" ref="deviceDetailMaskLeft"></div>
      <div class="maskRight">
        <div class="maskRightOne"></div>
        <div class="maskRightTwo" ref="deviceDetailMaskRightTwo"></div>
        <div class="maskRightThree"></div>
      </div>
    </div> -->
	</div>
</template>

<script>
// 引入(未配置webpack)
// var introJS=require("intro.js");
import Vue from 'vue';
import { i18n } from '@/i18n';

export default {
  data(){
    return {
      // 盒子显隐
      introBoxVisible: true,
      beforeBoxVisible: false,
      myDeviceBoxVisible: true,
      proManageBoxVisible: false,
      myDeviceDetailBoxVisible: false,
      // 步骤圆点列表
      dotList:[
        {step:0, label: 'active'},
        {step:1, label: 'default'},
        {step:2, label: 'default'},
        {step:3, label: 'default'},
        // {step:4, label: 'default'},
        // {step:5, label: 'default'},
      ],
      // 当前步骤标记
      stepCurMark: 0,
      // 当前页面标记
      // pageCurMark: 0,
      // 新手指引背景图
      currentLangBgi: '',
    };
  },
	mounted(){
		// this.initIntro();
    // 新手指引背景图是否考虑国际化
    // this.$lang.currentLang

    // zh_CN、en_US、en_ID
    // if(this.$lang.currentLang == 'zh_CN') {
    //   // console.log("z");
    //   // document.location.protocol
    //   this.currentLangBgi = '../../assets/img/introNew/generalIntro_myDevicePage.png';
    // } else if(this.$lang.currentLang == 'en_US'){
    //   // console.log("u");
    //   this.currentLangBgi = '../../assets/img/introNew/generalIntro_myDeviceDetailPage.png';
    // } else if(this.$lang.currentLang == 'en_ID'){
    //   // console.log("i");
    //   this.currentLangBgi = '../../assets/img/introNew/generalIntro_myDevicePage.png';
    // }
	},
  // computed: {
  //   currentLang() {
  //     return this.$lang.currentLang;
  //   },
  // },
  // watch: {
  //   // currentLangBgi
  //   '$lang.currentLang': {
  //     handler(val) {
  //       console.log("bgi", val)
  //       // this.queryData()
  //     },
  //     deep: true
  //   },
  // },
  methods: {
    guideSkip(){
      this.introBoxVisible = false;
      this.$router.go(-1);
    },
    // 进入第一步
    guideEnterStepOne(){
      this.beforeBoxVisible = false;
      this.myDeviceBoxVisible = true;
    },
    // 激活步骤圆点
    enableDot(item){
      // console.log("enableDot");
      this.dotList.forEach((dot)=>{
        Vue.set(this.dotList[dot.step], `label`, `default`);
      })
      // 反引号
      Vue.set(this.dotList[item.step], `label`, `active`);
      // 更新当前步骤
      this.stepCurMark = item.step;
      this.curStepChangeStyle();
    },
    // 上一步
    enablePreDot() {
      this.stepCurMark += -1;
      this.curStepChangeStyle();
    },
    // 下一步
    enableNextDot() {
      this.stepCurMark += 1;
      this.curStepChangeStyle();
    },
    // 切换滑块箭头在上
    arrowToWithTop(){
      this.$refs.arrowToEle.style.transform = 'rotateX('+'180'+'deg)';
      this.$refs.arrowToEle.style.top = '-'+48+'px';
      this.$refs.arrowToEle.style.bottom = 'unset';
    },
    // 切换滑块箭头在下
    arrowToWithBottom(){
      this.$refs.arrowToEle.style.transform = 'rotateX('+'0'+'deg)';
      this.$refs.arrowToEle.style.top = 'unset';
      this.$refs.arrowToEle.style.bottom = '-'+48+'px';
    },
    // 根据当前步骤改变页面样式
    curStepChangeStyle(){
      // 如果ref方式有问题则改用querySelector方式
      // const moveId = document.querySelector("#posIdPro");

      // 滑块=》我的设备-项目管理按钮
      if(this.stepCurMark==0){
        this.myDeviceBoxVisible = true;
        this.proManageBoxVisible = false;
        this.myDeviceDetailBoxVisible = false;

        // 滑块箭头
        this.arrowToWithBottom();
        // 滑块位置
        this.$refs.sliderEle.style.top = 'unset';
        this.$refs.sliderEle.style.bottom = 62+'px';
        this.$refs.sliderEle.style.left = 19+'%';
        // 页面遮罩
        this.$refs.deviceMaskLeft.style.background = 'transparent';
        this.$refs.deviceMaskRightTwo.style.background = 'rgba('+0+','+0+','+0+','+0.6+')';
        // 滑块文字
        this.$refs.varStepTitle.innerText = `1.${i18n.t('intro.step_project_1')}`;
        this.$refs.varStepContent.innerHTML = `${i18n.t('intro.step_project_2')}<span class="lightText">「${i18n.t('intro.step_project_3')}」</span>${i18n.t('intro.step_project_4')}
        <span class="lightText">${i18n.t('intro.step_project_5')}</span>。`;
      }
      // 滑块=》项目管理-切换项目按钮
      // if(this.stepCurMark==1){
      //   this.myDeviceBoxVisible = false;
      //   this.proManageBoxVisible = true;
      //   this.myDeviceDetailBoxVisible = false;

      //   // 滑块箭头
      //   this.arrowToWithTop();
      //   // 滑块位置
      //   this.$refs.sliderEle.style.top = 30+'%';
      //   this.$refs.sliderEle.style.left = 16+'%';
      //   // 滑块文字
      //   this.$refs.varStepTitle.innerText = `1.更系统的管理设备`;
      //   this.$refs.varStepContent.innerHTML = `默认项目不可进行删除，<span class="lightText">鼠标悬停</span>在项目上时，可进行<span class="lightText">编辑与删除</span>的操作。`;
      // }
      // 滑块=》我的设备-模式切换按钮
      if(this.stepCurMark==1){
        this.myDeviceBoxVisible = true;
        this.proManageBoxVisible = false;
        this.myDeviceDetailBoxVisible = false;

        // 滑块箭头
        this.arrowToWithTop();
        // 滑块位置
        this.$refs.sliderEle.style.top = 36+'%';
        this.$refs.sliderEle.style.bottom = 'unset';
        this.$refs.sliderEle.style.left = 18+'%';
        // 页面遮罩
        this.$refs.deviceMaskLeft.style.background = 'transparent';
        this.$refs.deviceMaskRightTwo.style.background = 'rgba('+0+','+0+','+0+','+0.6+')';
        // 滑块文字
        this.$refs.varStepTitle.innerText = `2.${i18n.t('intro.step_mode_1')}`;
        this.$refs.varStepContent.innerHTML = `${i18n.t('intro.step_mode_2')}<span class="lightText">${i18n.t('intro.step_mode_3')}</span>${i18n.t('intro.step_mode_4')}`;
      }
      // 滑块=》我的设备-设备条目
      if(this.stepCurMark==2){
        this.myDeviceBoxVisible = true;
        this.proManageBoxVisible = false;
        this.myDeviceDetailBoxVisible = false;

        // 滑块箭头
        this.arrowToWithTop();
        // 滑块位置
        this.$refs.sliderEle.style.top = 46+'%';
        this.$refs.sliderEle.style.bottom = 'unset';
        this.$refs.sliderEle.style.left = 16+'%';
        // 页面遮罩
        this.$refs.deviceMaskLeft.style.background = 'transparent';
        this.$refs.deviceMaskRightTwo.style.background = 'rgba('+0+','+0+','+0+','+0.6+')';
        // 滑块文字
        this.$refs.varStepTitle.innerText = `3.${i18n.t('intro.step_device_1')}`;
        this.$refs.varStepContent.innerHTML = `${i18n.t('intro.step_device_2')}<span class="lightText">「${i18n.t('intro.step_device_3')}」</span>${i18n.t('intro.step_device_4')}<span class="lightText">${i18n.t('intro.step_device_5')}</span>${i18n.t('intro.step_device_6')}<span class="lightText">${i18n.t('intro.step_device_7')}</span>${i18n.t('intro.step_device_8')}<span class="lightText">${i18n.t('intro.step_device_9')}</span>${i18n.t('intro.step_device_10')}`;
      }
      // 滑块=》我的设备-设备操作
      if(this.stepCurMark==3){
        this.myDeviceBoxVisible = true;
        this.proManageBoxVisible = false;
        this.myDeviceDetailBoxVisible = false;

        // 滑块箭头
        this.arrowToWithTop();
        // 滑块位置
        this.$refs.sliderEle.style.top = 23+'%';
        this.$refs.sliderEle.style.bottom = 'unset';
        this.$refs.sliderEle.style.left = 66+'%';
        // 页面遮罩
        this.$refs.deviceMaskLeft.style.background = 'rgba('+0+','+0+','+0+','+0.6+')';
        this.$refs.deviceMaskRightTwo.style.background = 'transparent';
        // 滑块文字
        this.$refs.varStepTitle.innerText = `4.${i18n.t('intro.step_operate_1')}`;
        this.$refs.varStepContent.innerHTML = `${i18n.t('intro.step_operate_2')}`;
      }
      // 滑块=》我的设备-设备详情
      // if(this.stepCurMark==5){
      //   this.myDeviceBoxVisible = false;
      //   this.proManageBoxVisible = false;
      //   this.myDeviceDetailBoxVisible = true;

      //   // 滑块箭头
      //   this.arrowToWithTop();
      //   // 滑块位置
      //   this.$refs.sliderEle.style.top = 68+'%';
      //   this.$refs.sliderEle.style.left = 50+'%';
      //   // 页面遮罩
      //   this.$refs.deviceDetailMaskLeft.style.background = 'rgba('+0+','+0+','+0+','+0.6+')';
      //   this.$refs.deviceDetailMaskRightTwo.style.background = 'transparent';
      //   // 滑块文字
      //   this.$refs.varStepTitle.innerText = `5.采集器详情`;
      //   this.$refs.varStepContent.innerHTML = `点击设备详情后，可以查看设备所属采集器的详情信息以及采集器下的所有连接信息`;
      // }
    },
  }
}
</script>
<style lang="less">
// 去除scoped(解决innerHTML样式无效问题)
@import url("../../assets/css/mixin.less");
// 新手引导
.generalIntroBox {
  z-index:10;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2100;
  // 引导滑块
  .guideSlider {
    position: absolute;
    // top: 100px;
    // left: 100px;
    // top: 68%;
    bottom: 62px;
    left: 19%;
    width: 430px;
    padding: 20px 12px;
    background: rgba(37, 53, 78, 1);
    box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
    z-index: 10;
    // 箭头
    .arrowTo {
      position: absolute;
      bottom: -48px;
      left: -60px;
      width: 50px;
      height: 90px;
      background: url('../../assets/img/general/guide_arrowTo.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
    // 标题
    .guideSliderTitle {
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .titleIcon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('../../assets/img/introNew/guideSliderTitleIcon.png');
        background-repeat: no-repeat;
        background-size: contain;
        margin-right: 8px;
      }
    }
    .bottomLine {
      width: 100%;
      height: 12px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      position: relative;
    }
    .bottomLine:before{
      content:'';
      position: absolute;
      display: inline-block;
      bottom: -2px;
      left: 0;
      width: 34px;
      height: 3px;
      background: rgba(255, 255, 255, 1);
    }
    .bottomLine:after{
      content:'';
      position: absolute;
      display: inline-block;
      bottom: -1px;
      right: 0;
      width: 15px;
      height: 3px;
      background: url('../../assets/img/general/guide_bottomLine_after.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
    .guideSliderContent {
      padding: 10px;
      background: rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.7);
      margin: 16px 0px;
      .lightText {
        color: rgba(24, 254, 254, 1);
      }
    }
    .guideSliderOperate {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .stepDot {
        .dotDefault {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background: rgba(255, 255, 255, 0.5);
          margin-right: 8px;
          cursor: pointer;
          &:hover {
            width: 12px;
          }
          &.dotActive {
            width: 12px;
            background: rgba(24, 254, 254, 1);
          }
        }
      }
      .stepBtn {
        .btnPre {
          padding: 6px 12px;
          border: 1px solid rgba(24, 254, 254, 1);
          border-radius: 6px;
          background: transparent;
          color: rgba(24, 254, 254, 1);
          margin-left: 10px;
          cursor: pointer;
        }
        .btnNext {
          padding: 6px 12px;
          border: 1px solid rgba(24, 254, 254, 1);
          border-radius: 6px;
          background: rgba(24, 254, 254, 1);
          color: rgba(34, 45, 53, 1);
          margin-left: 10px;
          cursor: pointer;
        }
        .btnQuit {
          border:none;
          background: transparent;
          color: #1e99a6;
          cursor: pointer;
          margin-right: 12px;
        }
      }
    }
  }
  // 引导前页
  .guideBeforeBox {
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.6);
    background: url('../../assets/img/introNew/generalIntro_myDevicePage.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      .guideBeforeCell {
        background: transparent;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .guideBeforeTitle {
          color: rgba(255, 255, 255, 1);
          font-family: YouSheBiaoTiHei;
          font-size: 40px;
        }
        .guideBeforeBtn {
          margin-top: 86px;
          margin-bottom: 46px;
          .guideBeforeBtnSkip {
            font-size: 16px;
            padding:6px 12px;
            background: transparent;
            color: rgba(24, 254, 254, 1);
            border: 1px solid rgba(24, 254, 254, 1);
            border-radius: 6px;
            cursor: pointer;
            margin-right: 60px;
          }
          .guideBeforeBtnEnter {
            font-size: 16px;
            padding:6px 12px;
            background: rgba(24, 254, 254, 1);
            color: rgba(34, 45, 53, 1);
            border: 1px solid rgba(24, 254, 254, 1);
            border-radius: 6px;
            cursor: pointer;
          }
        }
        .guideBeforeTip {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.4);
        }
      }
    }
  }
  // 我的设备页
  .myDeviceBox {
    position: relative;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/introNew/generalIntro_myDevicePage.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    .maskLeft {
      width: 17%;
      height: 100%;
      background: transparent;
    }
    .maskRight {
      flex: 1;
      // width: 90%;
      height: 100%;
      // background: rgba(0, 0, 0, 0.6);
      .maskRightOne {
        width: 100%;
        height: 8.7%;
        background: rgba(0, 0, 0, 0.6);
      }
      .maskRightTwo {
        width: 100%;
        height: 14%;
        background: rgba(0, 0, 0, 0.6);
      }
      .maskRightThree {
        width: 100%;
        height: 77.3%;
        background: rgba(0, 0, 0, 0.6);
      }
    }
    // .aimPos {
    //   position: absolute;
    //   left: 30px;
    //   bottom: 30px;
    //   display: inline-block;
    //   width: 30px;
    //   height: 30px;
    //   background: red;
    // }
  }
  // 项目管理页
  .proManageBox {
    position: relative;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/introNew/generalIntro_proManagePage.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    .maskLeft {
      width: 14%;
      height: 100%;
      background: transparent;
    }
    .maskRight {
      flex: 1;
      // width: 90%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
    }
  }
  // 我的设备页设备详情页
  .myDeviceDetailBox {
    position: relative;
    width: 100%;
    height: 100%;
    background: url('../../assets/img/introNew/generalIntro_myDeviceDetailPage.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    .maskLeft {
      width: 17%;
      height: 100%;
      background: transparent;
    }
    .maskRight {
      flex: 1;
      // width: 90%;
      height: 100%;
      // background: rgba(0, 0, 0, 0.6);
      .maskRightOne {
        width: 100%;
        height: 56%;
        background: rgba(0, 0, 0, 0.6);
      }
      .maskRightTwo {
        width: 100%;
        height: 10%;
        background: rgba(0, 0, 0, 0.6);
      }
      .maskRightThree {
        width: 100%;
        height: 34%;
        background: rgba(0, 0, 0, 0.6);
      }
    }
  }
}


</style>
